import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./i18n.ts";
import "./index.css";
import { App } from "./App.tsx";
import { installGlobalErrorHandlers } from "./lib/observability.ts";
import { bootstrapServiceWorker } from "./lib/sw-update.ts";
import { bootstrapTheme } from "./lib/theme.ts";
// Importing the store runs its persist-rehydrate, which re-applies the
// data-density attribute on <html> before first paint (like bootstrapTheme).
import "./stores/ui-store.ts";

const rootElement = document.getElementById("root");
if (!rootElement) throw new Error("Root element not found");

bootstrapTheme();
installGlobalErrorHandlers();

createRoot(rootElement).render(
	<StrictMode>
		<App />
	</StrictMode>,
);

bootstrapServiceWorker();
